import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export function StatTile({
  label,
  value,
  note,
  tone = "default",
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  note?: ReactNode;
  tone?: "default" | "primary" | "success" | "warning" | "danger" | "info" | "violet";
  className?: string;
}) {
  const tones = {
    default: "border-border bg-card",
    primary: "border-primary/25 bg-primary-dim",
    success: "border-success/25 bg-success-dim",
    warning: "border-warning/25 bg-warning-dim",
    danger: "border-danger/25 bg-danger-dim",
    info: "border-info/25 bg-info-dim",
    violet: "border-violet/25 bg-violet-dim",
  } as const;

  return (
    <div className={cn("rounded-lg border p-4 transition-all hover:-translate-y-0.5", tones[tone], className)}>
      <div className="text-[10.5px] font-semibold uppercase tracking-[0.08em] text-text3">{label}</div>
      <div className="mono mt-2 text-[22px] font-bold leading-none text-text">{value}</div>
      {note && <div className="mt-2 text-[11px] text-text2">{note}</div>}
    </div>
  );
}
